export const parseIsoString = (value: unknown): string | null => {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  return null;
};

export const buildBatchPlaceholders = (rows: number, columns: number): string =>
  Array.from({ length: rows }, () => `(${Array(columns).fill('?').join(', ')})`).join(', ');
